export enum AnnexStatusEnum {
  Draft = 1,
  PendingApproval = 2,
  GeneratingSignedAnnex = 3,
  Accepted = 4,
  Active = 5,
  Inactive = 6,
  TerminatedAnnex = 7,
}
